<template>
  <div class="ele-body">
    <el-card shadow="never">
      <div class="ele-table-tool ele-table-tool-default">
        <el-button @click="showEdit = true" type="primary" icon="el-icon-plus" class="ele-btn-icon">添加清空在宿时间</el-button>
      </div>
      <!--数据表格-->
      <ele-data-table ref="table" :config="table" :choose.sync="choose" highlight-current-row style="margin-top: 10px">
        <template #default="{ index }">
          <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
          <el-table-column prop="recordTime" label="清空在宿时间" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column prop="createTime" label="创建时间" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column fixed="right" label="操作" width="240px" align="center" :resizable="false">
            <template #default="{ row }">
              <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false">修改</el-link>
              <el-popconfirm title="确定要删除此选项吗？" @onConfirm="deleteTime(row)" class="ele-action">
                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
              </el-popconfirm>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-card>

    <!--编辑弹窗-->
    <el-dialog
      :title="editForm.id ? '修改清空在宿时间' : '添加清空在宿时间'"
      :visible.sync="showEdit"
      width="400px"
      @closed="editForm = {}"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
    >
      <el-form ref="editForm" :model="editForm" :rules="editRules" label-width="140px">
        <el-form-item label="设置清空在宿时间:" prop="recordTime">
          <el-time-picker v-model="editForm.recordTime" placeholder="选择清空在宿时间" value-format="HH:mm:00" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEdit = false">取 消</el-button>
        <el-button type="primary" @click="save(editForm.id)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { addDormitoryClearTime, deleteDormitoryClearTime, updateDormitoryClearTime } from '@/config/api';

  export default {
    name: 'ClearTime',
    data() {
      return {
        table: {
          // 表格配置
          url: '/dormitoryClearTime/getDormitoryClearTimeList',
          method: 'GET',
          where: {},
          page: false,
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            return res;
          },
        },
        editForm: {},
        editRules: {
          // 表单验证规则
          recordTime: [{ required: true, message: '请选择清空在宿时间', trigger: 'blur' }],
        },
        choose: [], // 表格选中数据
        showEdit: false,
      };
    },
    methods: {
      // 编辑显示弹窗
      edit(row) {
        this.editForm = Object.assign({}, row);
        this.showEdit = true;
      },
      // 保存
      save(id) {
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.editForm) {
              if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
                formData.append(key, this.editForm[key]);
              }
            }
            if (id == undefined) {
              //添加静默时间
              addDormitoryClearTime(formData).then((res) => {
                loading.close();
                if (res.data.resCode == 200) {
                  this.showEdit = false;
                  this.$message({ type: 'success', message: res.data.resMsg });
                  this.$refs.table.reload();
                } else {
                  this.$message.error(res.data.resMsg);
                }
              });
            } else {
              updateDormitoryClearTime(formData).then((res) => {
                loading.close();
                if (res.data.resCode == 200) {
                  this.showEdit = false;
                  this.$message({ type: 'success', message: res.data.resMsg });
                  this.$refs.table.reload();
                } else {
                  this.$message.error(res.data.resMsg);
                }
              });
            }
          } else {
            return false;
          }
        });
      },
      //删除时间
      deleteTime(row) {
        let data = new FormData();
        data.append('id', row.id);
        deleteDormitoryClearTime(data).then((res) => {
          if (res.data.resCode == 200) {
            this.$message({ type: 'success', message: '已删除' });
            this.$refs.table.reload();
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
    },
  };
</script>

<style scoped></style>
